'use strict';

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/app/node_modules/@babel/runtime/helpers/inherits");

var Span = require('opentracing').Span;

var NoopSpanContext = require('../noop/span_context');

var id = require('../id');

var NoopSpan =
/*#__PURE__*/
function (_Span) {
  _inherits(NoopSpan, _Span);

  function NoopSpan(tracer, parent) {
    var _this;

    _classCallCheck(this, NoopSpan);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NoopSpan).call(this));
    _this._noopTracer = tracer;
    _this._noopContext = _this._createContext(parent);
    return _this;
  }

  _createClass(NoopSpan, [{
    key: "_context",
    value: function _context() {
      return this._noopContext;
    }
  }, {
    key: "_tracer",
    value: function _tracer() {
      return this._noopTracer;
    }
  }, {
    key: "_createContext",
    value: function _createContext(parent) {
      var spanId = id();

      if (parent) {
        return new NoopSpanContext({
          noop: this,
          traceId: parent._traceId,
          spanId: spanId,
          parentId: parent._spanId,
          baggageItems: Object.assign({}, parent._baggageItems)
        });
      } else {
        return new NoopSpanContext({
          noop: this,
          traceId: spanId,
          spanId: spanId
        });
      }
    }
  }]);

  return NoopSpan;
}(Span);

module.exports = NoopSpan;